// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawer-table[data-v-721f62a4] {\n  width: 95%;\n  margin: auto;\n}\n.custom-btn[data-v-721f62a4] {\n  margin-left: 10px;\n}\n.dialog-footer[data-v-721f62a4] {\n  text-align: center;\n  margin-top: 25px;\n}", ""]);
// Exports
module.exports = exports;
